/**
 * Created by or_p on 7/18/2016.
 */
import * as elementLayoutActions from '../actions/elementLayoutActions';
import { ALIGN_DIRECTION } from '../actions/elementLayoutActions';
import { getViewState } from '../helpers/elementViewHelpers';
import update from 'react-addons-update';
import { getElementList } from '../helpers/elementListHelpers';
import _ from 'lodash';
import {isFullWidthComponent, getBoundingLayout} from '../helpers/elementPositionHelpers';

export default function reducer(state = {}, action = {}) {
  if (action.type !== elementLayoutActions.ALIGN_SELECTED_ELEMENTS) {
    return state;
  }
  let viewState;
  const elementsToUpdate = {};
  let element;
  let elementId;
  let elementList;


  viewState = getViewState(action.viewMode, state);
  elementId = action.ids[0];
  elementList = getElementList(elementId);
  const elements = _.map(action.ids, (id) => {
    return state[viewState].elements[id];
  });
  const pageWidth = state[viewState].staticElements.page.layout.width;
  const boundingLayout = getBoundingLayout(elements, pageWidth);
  switch (action.direction) {
    case ALIGN_DIRECTION.PAGE_LEFT:
      _.forEach(action.ids, (id) => {
        element = state[viewState].elements[id];
        if (isFullWidthComponent(element)) {
          return;
        }
        elementsToUpdate[id] = {
          layout: {
            x: {
              $set: 0
            },
          }
        };
      });
      break;
    case ALIGN_DIRECTION.PAGE_CENTER:
      _.forEach(action.ids, (id) => {
        element = state[viewState].elements[id];
        if (isFullWidthComponent(element)) {
          return;
        }
        elementsToUpdate[id] = {
          layout: {
            x: {
              $set: (pageWidth - element.layout.width) / 2
            },
          }
        };
      });
      break;
    case ALIGN_DIRECTION.PAGE_RIGHT:
      _.forEach(action.ids, (id) => {
        element = state[viewState].elements[id];
        if (isFullWidthComponent(element)) {
          return;
        }
        elementsToUpdate[id] = {
          layout: {
            x: {
              $set: pageWidth - element.layout.width
            },
          }
        };
      });
      break;
    case ALIGN_DIRECTION.LEFT:
      _.forEach(action.ids, (id) => {
        element = state[viewState].elements[id];
        if (isFullWidthComponent(element)) {
          return;
        }
        elementsToUpdate[id] = {
          layout: {
            x: {
              $set: boundingLayout.xStart
            },
          }
        };
      });
      break;
    case ALIGN_DIRECTION.CENTER_HORIZONTAL:
      _.forEach(action.ids, (id) => {
        element = state[viewState].elements[id];
        if (isFullWidthComponent(element)) {
          return;
        }
        elementsToUpdate[id] = {
          layout: {
            x: {
              $set: boundingLayout.xStart + ((boundingLayout.width - element.layout.width) / 2)
            },
          }
        };
      });
      break;
    case ALIGN_DIRECTION.RIGHT:
      _.forEach(action.ids, (id) => {
        element = state[viewState].elements[id];
        if (isFullWidthComponent(element)) {
          return;
        }
        elementsToUpdate[id] = {
          layout: {
            x: {
              $set: boundingLayout.xStart + (boundingLayout.width - element.layout.width)
            },
          }
        };
      });
      break;
    case ALIGN_DIRECTION.TOP:
      _.forEach(action.ids, (id) => {
        element = state[viewState].elements[id];
        elementsToUpdate[id] = {
          layout: {
            y: {
              $set: boundingLayout.yStart
            },
          }
        };
      });
      break;
    case ALIGN_DIRECTION.CENTER_VERTICAL:
      _.forEach(action.ids, (id) => {
        element = state[viewState].elements[id];
        elementsToUpdate[id] = {
          layout: {
            y: {
              $set: boundingLayout.yStart + ((boundingLayout.height - element.layout.height) / 2)
            },
          }
        };
      });
      break;
    case ALIGN_DIRECTION.BOTTOM:
      _.forEach(action.ids, (id) => {
        element = state[viewState].elements[id];
        elementsToUpdate[id] = {
          layout: {
            y: {
              $set: boundingLayout.yStart + (boundingLayout.height - element.layout.height)
            },
          }
        };
      });
      break;
    default:
      return state;
  }
  return update(state, {
    [viewState]: {
      [elementList]: elementsToUpdate
    }
  });
}
